<button
  [class]="btnType + ' ' + type + ' ' + size + ' ' + witch + ' ' + alter + (bold ? ' fw-bold' : '')"
  [disabled]="disabled"
  (click)="onClick()"
>
  {{ text }}
</button>
